var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShop = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 25 25"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#231F20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M19 11.765V20H6v-8.235M7.625 8.47h9.75V6h-9.75zM19 10.94v.824c0 .909-.728 1.647-1.625 1.647a1.637 1.637 0 0 1-1.625-1.647c0 .909-.728 1.647-1.625 1.647a1.637 1.637 0 0 1-1.625-1.647c0 .909-.728 1.647-1.625 1.647a1.637 1.637 0 0 1-1.625-1.647c0 .909-.728 1.647-1.625 1.647A1.637 1.637 0 0 1 6 11.765v-.824l1.625-2.47h9.75zM7.625 20h2.438v-4.941H7.624zm4.063-1.647h5.687v-3.294h-5.687z"
})));
export default SvgShop;